<template>
  <div class="room ventilation" v-loading="loadingData">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="device-block-multi">
      <div class="device-block" :class="warningFlagLeft">
        <div class="device-block-line-chart">
          <DoubleGraph :opts="humidityLineOpts" :series="humidityLineData"></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap :opts="humidityBarOpts" :series="humidityBarData"></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="air-wrap" :class="warningFlagRight">
        <div class="air-title">{{ this.stationName }}温湿度</div>
        <div class="air-chart-wrap">
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOpts1"
            :series="singlePieHistogramWrapData1"
            :class="singlePieHistogramWarningFlag1"
          ></SinglePieHistogramWrap>
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOpts2"
            :series="singlePieHistogramWrapData2"
            :class="singlePieHistogramWarningFlag2"
          ></SinglePieHistogramWrap>
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOpts3"
            :series="singlePieHistogramWrapData3"
            :class="singlePieHistogramWarningFlag3"
          ></SinglePieHistogramWrap>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleLeftL1" :series="switchDataLeftL1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeftL2" :series="switchDataLeftL2"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeftL3" :series="switchDataLeftL3"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeftL4" :series="switchDataLeftL4"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleLeftR1" :series="switchDataLeftR1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeftR2" :series="switchDataLeftR2"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeftR3" :series="switchDataLeftR3"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeftR4" :series="switchDataLeftR4"></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig class="running-time-item-left" :title="runningTimeTitleLeft" :series="runningTimeDataLeft" :isHour="true"></RunningTimeBig>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleRightL1" :series="switchDataRightL1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRightL2" :series="switchDataRightL2"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRightL3" :series="switchDataRightL3"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleRightR1" :series="switchDataRightR1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRightR2" :series="switchDataRightR2"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRightR3" :series="switchDataRightR3"></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig class="running-time-item-right" :title="runningTimeTitleRight" :series="runningTimeDataRight" :isHour="true"></RunningTimeBig>
      </div>
    </div>
  </div>
</template>

<script>
import configJson from "./config/anchorRoom.json";

export default {
  name: "ventilationNew",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      stationName: "",
      deviceList: [],

      switchTitleLeftL1: "除湿机运行",
      switchTitleLeftL2: "处理压差报警",
      switchTitleLeftL3: "一级除湿",
      switchTitleLeftL4: "设定一级除湿",
      switchTitleLeftR1: "除湿机故障",
      switchTitleLeftR2: "再生压差报警",
      switchTitleLeftR3: "二级除湿",
      switchTitleLeftR4: "设定二级除湿",
      runningTimeTitleLeft: "除湿机运行时间",

      switchTitleRightL1: "风机运行",
      switchTitleRightL2: "除湿机控制选择",
      switchTitleRightL3: "系统运行",
      switchTitleRightR1: "风机故障",
      switchTitleRightR2: "风机开启",
      switchTitleRightR3: "系统报警",
      runningTimeTitleRight: "风机运行时间",

      singleHisDataLeft1: {},
      singleHisDataLeft2: {},
      singleHisDataLeft3: {},

      singlePieHistogramWrapData1: {},
      singlePieHistogramWrapData2: {},
      singlePieHistogramWrapData3: {},

      switchDataLeftL1: {},
      switchDataLeftL2: {},
      switchDataLeftL3: {},
      switchDataLeftL4: {},
      switchDataLeftR1: {},
      switchDataLeftR2: {},
      switchDataLeftR3: {},
      switchDataLeftR4: {},
      switchDataRightL1: {},
      switchDataRightL2: {},
      switchDataRightL3: {},
      switchDataRightR1: {},
      switchDataRightR2: {},
      switchDataRightR3: {},
      runningTimeDataLeft: "",
      runningTimeDataRight: "",

      warningFlagLeft: "",
      warningFlagRight: "",

      singlePieHistogramWarningFlag1: "",
      singlePieHistogramWarningFlag2: "",
      singlePieHistogramWarningFlag3: "",

      humidityLineData: null,
      humidityBarData: null,
    };
  },
  computed: {
    singlePieHistogramWrapOpts1: function () {
      return {
        title: "锚室温湿度1",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOpts2: function () {
      return {
        title: "锚室温湿度2",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOpts3: function () {
      return {
        title: "锚室温湿度3",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    humidityLineOpts: function () {
      return {
        title: this.stationName + "除湿机温湿度",
        legend1: "湿度",
        legend2: "温度",
      };
    },
    humidityBarOpts: function () {
      return {
        title: "除湿机温湿度",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      this.deviceList = configJson[routerPath[3]].deviceList;
      // const deviceName = configJson[routerPath[3]].deviceName;
      // this.deviceLeftName = deviceName.deviceLeftName;
      // this.deviceRightName = deviceName.deviceRightName;
      this.stationId = configJson[routerPath[3]].stationId;
      this.stationName = configJson[routerPath[3]].stationName;
      this.bridgeSegmentName = configJson[routerPath[3]].bridgeSegmentName;
    },
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getLineChartData();

      let request = this.getCurrentData(this.stationId);
      request.then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);
        let currentData = res.data;

        this.setPieHistogramDataAndError(currentData, "humidityBarData", "除湿机温度", "除湿机湿度", "warningFlagLeft");

        this.setPieHistogramDataAndError(currentData, "singlePieHistogramWrapData1", "锚室温度1", "锚室湿度1", "singlePieHistogramWarningFlag1");

        this.setPieHistogramDataAndError(currentData, "singlePieHistogramWrapData2", "锚室温度2", "锚室湿度2", "singlePieHistogramWarningFlag2");

        this.setPieHistogramDataAndError(currentData, "singlePieHistogramWrapData3", "锚室温度3", "锚室湿度3", "singlePieHistogramWarningFlag3");

        const switchIdLeftL1 = this.findDeviceId(this.switchTitleLeftL1);
        const switchIdLeftL2 = this.findDeviceId(this.switchTitleLeftL2);
        const switchIdLeftL3 = this.findDeviceId(this.switchTitleLeftL3);
        const switchIdLeftL4 = this.findDeviceId(this.switchTitleLeftL4);
        const switchIdLeftR1 = this.findDeviceId(this.switchTitleLeftR1);
        const switchIdLeftR2 = this.findDeviceId(this.switchTitleLeftR2);
        const switchIdLeftR3 = this.findDeviceId(this.switchTitleLeftR3);
        const switchIdLeftR4 = this.findDeviceId(this.switchTitleLeftR4);
        this.switchDataLeftL1 = {
          data: currentData[switchIdLeftL1].value,
          isError: currentData[switchIdLeftL1].errorLevel,
        };
        this.switchDataLeftL2 = {
          data: currentData[switchIdLeftL2].value,
          isError: currentData[switchIdLeftL2].errorLevel,
          isZh: true,
        };
        this.switchDataLeftL3 = {
          data: currentData[switchIdLeftL3].value,
          isError: currentData[switchIdLeftL3].errorLevel,
        };
        this.switchDataLeftL4 = {
          data: currentData[switchIdLeftL4].value,
          isError: currentData[switchIdLeftL4].errorLevel,
        };
        this.switchDataLeftR1 = {
          data: currentData[switchIdLeftR1].value,
          isError: currentData[switchIdLeftR1].errorLevel,
          isZh: true,
        };
        this.switchDataLeftR2 = {
          data: currentData[switchIdLeftR2].value,
          isError: currentData[switchIdLeftR2].errorLevel,
          isZh: true,
        };
        this.switchDataLeftR3 = {
          data: currentData[switchIdLeftR3].value,
          isError: currentData[switchIdLeftR3].errorLevel,
        };
        this.switchDataLeftR4 = {
          data: currentData[switchIdLeftR4].value,
          isError: currentData[switchIdLeftR4].errorLevel,
        };

        const switchIdRightL1 = this.findDeviceId(this.switchTitleRightL1);
        const switchIdRightL2 = this.findDeviceId(this.switchTitleRightL2);
        const switchIdRightL3 = this.findDeviceId(this.switchTitleRightL3);
        const switchIdRightR1 = this.findDeviceId(this.switchTitleRightR1);
        const switchIdRightR2 = this.findDeviceId(this.switchTitleRightR2);
        const switchIdRightR3 = this.findDeviceId(this.switchTitleRightR3);
        this.switchDataRightL1 = {
          data: currentData[switchIdRightL1].value,
          isError: currentData[switchIdRightL1].errorLevel,
        };
        this.switchDataRightL2 = {
          data: currentData[switchIdRightL2].value,
          isError: currentData[switchIdRightL2].errorLevel,
          textOff: "最差",
          textOn: "平均",
        };
        this.switchDataRightL3 = {
          data: currentData[switchIdRightL3].value,
          isError: currentData[switchIdRightL3].errorLevel,
        };
        this.switchDataRightR1 = {
          data: currentData[switchIdRightR1].value,
          isError: currentData[switchIdRightR1].errorLevel,
          isZh: true,
        };
        this.switchDataRightR2 = {
          data: currentData[switchIdRightR2].value,
          isError: currentData[switchIdRightR2].errorLevel,
        };
        this.switchDataRightR3 = {
          data: currentData[switchIdRightR3].value,
          isError: currentData[switchIdRightR3].errorLevel,
          isZh: true,
        };

        const runningTimeIdLeft = this.findDeviceId(this.runningTimeTitleLeft);
        this.runningTimeDataLeft = currentData[runningTimeIdLeft].value;

        const runningTimeIdRight = this.findDeviceId(this.runningTimeTitleRight);
        this.runningTimeDataRight = currentData[runningTimeIdRight].value;
      });
    },

    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";

      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },

    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },

    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },

    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ventilation {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .running-time-item-left {
        height: calc(100% - 195px);
        width: 100%;
        box-sizing: border-box;
      }

      .running-time-item-right {
        height: calc(100% - 145px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .air-wrap {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: calc(50% - 10px);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;

    .air-title {
      padding: 20px 15px 10px 10px;
      font-size: 22px;
      color: #515151;
    }

    .air-chart-wrap {
      display: flex;
      height: 80%;
      flex: 1;
    }

    .air-chart {
      padding: 20px 0;
      box-sizing: border-box;
      width: 33.3333%;
    }

    .device-block-multi-item {
      width: calc((100% / 3) - 10px);
      // background-color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>
